class CfDeskOffer extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'});
    this.variants = JSON.parse(this.querySelector('[data-desk-variants]').textContent);
    this.area = this.closest('.product-details');
    this.form = this.area?.querySelector('product-form-component form');
    if (!this.form) return;
    this.button = this.form.querySelector('[name="add"]');
    for (const radio of this.querySelectorAll('input[type="radio"]')) radio.disabled = false;
    this.addEventListener('change',()=>this.refresh(),{signal:this.abort.signal});
    this.form.addEventListener('submit',event=>this.submit(event),{capture:true,signal:this.abort.signal});
    this.observer = new MutationObserver(()=>this.refresh());
    this.observer.observe(this.form.querySelector('[name="id"]'),{attributes:true,attributeFilter:['value']});
    this.refresh();
  }
  disconnectedCallback() {this.abort?.abort();this.abort=null;this.observer?.disconnect();}
  refresh() {
    this.variant = this.variants.find(v=>v.id===this.form.querySelector('[name="id"]').value);
    if (!this.variant) return;
    this.setup = this.querySelector('[value="setup"]').checked;
    this.querySelectorAll('[data-desk-option]').forEach(row=>row.classList.toggle('is-selected',row.dataset.deskOption===(this.setup?'setup':'single')));
    this.querySelector('[data-desk-single]').textContent=this.money.format(this.variant.price/100);
    const addon=this.querySelector('[data-desk-addon]');
    this.total=addon?this.variant.price+Number(addon.dataset.price):Number(this.querySelector('[data-desk-bundle]').dataset.price);
    this.querySelector('[data-desk-total]').textContent=this.money.format(this.total/100);
    const primaryReference=Math.max(this.variant.price,Number(this.variant.compareAt)||0);
    const setReference=addon?primaryReference+Math.max(Number(addon.dataset.price),Number(addon.dataset.reference)||0):Math.max(this.total,Number(this.querySelector('[data-desk-bundle]').dataset.reference)||0);
    for(const [selector,reference,actual] of [['[data-desk-single-was]',primaryReference,this.variant.price],['[data-desk-base-was]',primaryReference,this.variant.price],['[data-desk-total-was]',setReference,this.total]]){
      const node=this.querySelector(selector);
      if(node){node.hidden=reference<=actual;node.textContent=this.money.format(reference/100);}
    }
    const pairSaving=this.querySelector('[data-desk-pair-saving]');
    if(pairSaving){pairSaving.hidden=setReference<=this.total;this.querySelector('[data-desk-pair-saved]').textContent=this.money.format((setReference-this.total)/100);}
    const basePrice=this.querySelector('[data-desk-base-price]');if(basePrice)basePrice.textContent=this.money.format(this.variant.price/100);
    const label=this.button.querySelector('.cf-atc__label'),price=this.button.querySelector('.cf-atc__price');
    this.button.disabled=!this.variant.available || this.busy;
    if(label)label.textContent=!this.variant.available?'Sold out':this.busy?'Adding…':this.setup?'Add the setup to cart':'Add to cart';
    if(price)price.textContent=this.money.format((this.setup?this.total:this.variant.price)/100);
  }
  async submit(event) {
    this.refresh();
    if(!this.setup)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(this.busy||!this.variant.available)return;
    const addon=this.querySelector('[data-desk-addon]');
    const items=addon?[{id:this.variant.id,quantity:1},{id:addon.value,quantity:1}]:[{id:this.querySelector('[data-desk-bundle]').value,quantity:1}];
    const error=this.querySelector('[data-desk-error]');error.hidden=true;this.busy=true;this.refresh();
    try {
      const response=await fetch(`${this.dataset.addUrl}.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      const result=await response.json();
      if(!response.ok||result.status)throw new Error(result.description||'This setup is unavailable. Please check your cart and try again.');
      if(Array.isArray(window.dataLayer))window.dataLayer.push({event:'desk_setup_added',product_id:this.dataset.productId,offer_type:this.dataset.mode});
      window.location.assign(this.dataset.cartUrl);
    } catch(failure) {
      error.textContent=failure.message||'We could not confirm the addition. Please check your cart before trying again.';error.hidden=false;this.busy=false;this.refresh();
    }
  }
}
if(!customElements.get('cf-desk-offer'))customElements.define('cf-desk-offer',CfDeskOffer);

